import {
	createReduxStore,
	createRegistrySelector,
	register,
} from "@wordpress/data";
// @ts-ignore
import { store } from "@wordpress/preferences";

export const MAGAZINE_BLOCKS_PREFERENCES: "magazine-blocks/preferences" =
	"magazine-blocks/preferences";

export const DEFAULT_INSERTERS = [
	"magazine-blocks/section",
	"magazine-blocks/heading",
];

export const preferencesStore = createReduxStore(MAGAZINE_BLOCKS_PREFERENCES, {
	reducer(state, action) {
		return state;
	},
	actions: {
		updateInserters:
			(inserters: Array<string>) =>
			({ registry }: any) => {
				registry
					.dispatch(store)
					.set("magazine-blocks/preferences", "inserters", inserters);
			},
		updateFavorites:
			(favorites: Array<string>) =>
			({ registry }: any) => {
				registry
					.dispatch(store)
					.set("magazine-blocks/preferences", "favorites", favorites);
			},
	},
	selectors: {
		getInserters: createRegistrySelector(
			(select: any) => () =>
				select(store).get("magazine-blocks/preferences", "inserters") ??
				DEFAULT_INSERTERS
		),
		getFavorites: createRegistrySelector(
			(select: any) => () =>
				select(store).get("magazine-blocks/preferences", "favorites") ??
				[]
		),
	},
});

register(preferencesStore);
